import type { FieldPath, FieldValues } from "react-hook-form";
import { CdcSelectField, type CdcSelectFieldProps } from "./cdc-field-helpers";
import { getCdcSalutationOptions } from "@/i18n/cdc-options";

export type CdcSalutationFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<CdcSelectFieldProps<TFieldValues, TName>, "fieldKey" | "options">;

export function CdcSalutationField<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({ locale, ...rest }: Readonly<CdcSalutationFieldProps<TFieldValues, TName>>) {
  return (
    <CdcSelectField
      {...rest}
      fieldKey="salutation"
      locale={locale}
      options={getCdcSalutationOptions(locale)}
    />
  );
}
